import ColorScale from "./ColorScale";
import { DB_TO_CL } from "../constants/options";

class DbCategoryColorScale {
  constructor(dbs) {
    this.dbs = dbs;
    this.disabled = new ColorScale(null, 1).setOpacity(0.2);
    this.index = new Map();
  }

  get vectors() {
    return Array.from(this.index.values())
      .filter((x) => x && x.color)
      .map((x) => x.color.vec);
  }

  get hexes() {
    return Array.from(this.index.values())
      .filter((x) => x && x.color)
      .map((x) => x.color.hex);
  }

  getKey(key) {
    return this.index.get(key);
  }

  calc(conf = {}, highlightedKey) {
    this.index = this.dbs
      .map((db, ind) => {
        const { categoryIndex: i, key, category, categorySize } = db;
        const theme = conf.isDark ? 2 : 1;
        const scaleName = conf[DB_TO_CL[category]];
        const hasColor = !highlightedKey || highlightedKey === key;
        const scale = new ColorScale(scaleName, categorySize).setTheme(theme);
        const color = hasColor ? scale.colors[i] : this.disabled.colors[0];
        return { key, color, ind, category };
      })
      .reduce((a, i) => a.set(i.key, i), new Map());

    return this;
  }
}

export default DbCategoryColorScale;
